<template>
    <div class="lazy-offers">
        <in-view-lazy-component name="OffersRevamp" :fetch-data="{ url }" @response="onResponse" @error="onError">
            <template #loading>
                <div class="skeleton skeleton--animation_pulse skeleton--size_md grid__wrapper overflow-hidden">
                    <div v-for="n in 2" :key="n" class="grid__item grid__item-12/12 grid__item-6/12--medium">
                        <div
                            class="grid__item skeleton__bone skeleton__bone--image skeleton__bone--rounded skeleton__bone--image-x7 skeleton__bone--width_full"
                        ></div>
                    </div>
                </div>
            </template>
            <template #default="{ component, response }">
                <component
                    :is="component"
                    :data="(response.data && response.data.data) || {}"
                    :make="make"
                    :model="model"
                    :full-name="fullName"
                    :image-src="imageSrc"
                    v-on="$listeners"
                />
            </template>
        </in-view-lazy-component>
    </div>
</template>

<script>
import { getApiUrl } from '@v4/config';
import { stringifyUrl } from '@v4/common/utils/url';
import InViewLazyComponent from '@v4/common/components/atoms/InViewLazyComponent';

export default {
    name: 'LazyOffersDST',
    components: {
        InViewLazyComponent,
    },
    props: {
        /**
         * Make name
         */
        make: {
            type: String,
            default: '',
        },
        /**
         * Model name
         */
        model: {
            type: String,
            default: '',
        },
        /**
         * Cover image
         */
        imageSrc: {
            type: String,
            default: '',
        },
        /**
         * Full name for VDP Revamp offers detail modal
         */
        fullName: {
            type: String,
            default: '',
        },
    },
    computed: {
        url() {
            return stringifyUrl({
                url: `${getApiUrl()}/dkwp/v3/offers/${this.make}/${this.model}`,
                query: { offer_vdp: 1 }, // eslint-disable-line camelcase
            });
        },
    },
    methods: {
        onResponse(...args) {
            /**
             * Fired when getting success response from `FetchData` component
             *
             * @event response
             * @type {object}
             * @property {object} payload - Payload data
             */
            this.$emit('response', ...args);
        },
        onError(...args) {
            /**
             * Fired when getting error response from `FetchData` component
             *
             * @event response
             * @type {object}
             * @property {object} payload - Payload data
             */
            this.$emit('error', ...args);
        },
    },
};
</script>
